import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';
import { auth, firestore } from '../config/firebase';
import type { Subscription } from '../types/subscription';
import { stripUndefinedFields } from './firestorePayload';

export function resolveAuth() {
  return typeof auth === 'function' ? auth() : auth;
}

export function resolveFirestore() {
  return firestore();
}

export function getCurrentUser() {
  return resolveAuth().currentUser;
}

function subscriptionDocRef(userId: string) {
  return doc(resolveFirestore(), 'users', userId, 'subscription', 'current');
}

function snapshotExists(snapshot: { exists: () => boolean }): boolean {
  return snapshot.exists();
}

function snapshotData<T>(snapshot: { data: () => T | undefined }): T | undefined {
  return snapshot.data();
}

export async function getSubscriptionDoc(userId: string): Promise<Subscription | null> {
  const snap = await getDoc(subscriptionDocRef(userId));
  return snap.exists() ? snapshotData<Subscription>(snap) ?? null : null;
}

export async function setSubscriptionDoc(userId: string, data: Subscription): Promise<void> {
  await setDoc(
    subscriptionDocRef(userId),
    stripUndefinedFields(data as unknown as Record<string, unknown>) as Subscription
  );
}

export function watchSubscriptionDoc(
  userId: string,
  onNext: (data: Subscription | null, exists: boolean) => void,
  onError: (error: Error) => void
): () => void {
  return onSnapshot(
    subscriptionDocRef(userId),
    snap => {
      const exists = snap.exists();
      onNext(exists ? snapshotData<Subscription>(snap) ?? null : null, exists);
    },
    onError
  );
}
